import { render, staticRenderFns } from "./ProgramParametersStartpage.vue?vue&type=template&id=6cfc3744&scoped=true&"
import script from "./ProgramParametersStartpage.vue?vue&type=script&lang=js&"
export * from "./ProgramParametersStartpage.vue?vue&type=script&lang=js&"
import style0 from "./ProgramParametersStartpage.vue?vue&type=style&index=0&id=6cfc3744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc3744",
  null
  
)

export default component.exports